import { render, staticRenderFns } from "./BirthCreate.vue?vue&type=template&id=1e4cb328"
import script from "./BirthCreate.vue?vue&type=script&lang=js"
export * from "./BirthCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports